import { Component, OnInit } from "@angular/core"
import { Modalable } from "@app/Modalable"
import { environment } from "@env/environment"

@Component({
	selector: "app-ita-get-auth",
	template: `
		<div class="modal-btns">
			<div>
				<!--    <p style="text-align: right;">{{ "ita_no_signup" | langVal }}</p>-->
				<p style="text-align: right;">
					במסגרת מודל חשבוניות ישראל, רשות המסים דורשת לקבל מספר הקצאה עבור כל
					עסקה שסכומה עולה על 20,000 ש"ח.
				</p>

				<p style="text-align: right;">
					לצורך כך, יש להצטרף לדיגיטל של רשות המסים. לאחר ההצטרפות, יש לקבל
					אישור מרשות המסים לביצוע פעולות אחת לשלושה חודשים, באמצעות לחיצה על
					הכפתור למטה.
				</p>

				<p style="text-align: right;">
					המערכת תזכיר שתוקף האישור עומד לפוג שבועיים לפני תום התקופה.
				</p>
				<div
					class="d-flex flex-column flex-sm-row"
					style="justify-content: space-evenly"
				>
					@if (!isRefreshToken) {
						<button class="btn btn-primary mb-3">
							<a
								href="https://secapp.taxes.gov.il/srRishum/main/imutZihuy"
								target="_blank"
								style="color:#fff;"
							>
								{{ "ita_sign_up" | langVal }}
							</a>
						</button>
					}

					<button class="btn btn-primary">
						<a
							[href]="itaUrl"
							style="color:#fff;"
						>
							{{ "ita_get_auth" | langVal }}
						</a>
					</button>
				</div>
			</div>
		</div>
	`,
})
export class ItaGetAuthComponent extends Modalable {
	modalWidth: string = "modal-650"
	modalTitleLang: string = "ita_get_auth"
	isRefreshToken = "false"
	isTokenExpired = false
	itaUrl: string = ""
	ngOnInit() {
		const cc = this.store.getCliniqDataOrExit()
		this.isRefreshToken = cc?.ita_refresh_token
		this.isTokenExpired = false // TODO check if ita_token_date is smaller or equal to today+week
		this.get_url()
	}
	get_url() {
		const client_id = "d8c0628aead8ed3276118af071799e7c"
    //const client_id = "b3ac6a868d9f15078159eda8252c7758"
		this.itaUrl = environment.serverUrl + "/qweqweewrtfgfdgvsedrhnbgv"

		//   const client_id='d8c0628aead8ed3276118af071799e7c';

  //   this.itaUrl ='https://ita-api.taxes.gov.il/shaam/production/longtimetoken/oauth2/authorize?response_type=code&client_id='+client_id+'&redirect_uri=https://app2.my-cliniq.com/wero54690thrj4w3r954'+'&scope=scope';
 }
}
